import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input } from '@angular/core';

import { SnUser } from '@lib/api/entities';
import { snListStagger, snFadeIn, snFadeOut } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';

@Component({
  selector: 'sn-user-requests-table',
  templateUrl: './user-requests-table.component.html',
  styleUrls: ['./user-requests-table.component.scss'],
  animations: [snListStagger, snFadeIn, snFadeOut],
})
export class UserRequestsTableComponent extends SnTableBaseComponent<SnUser> {
  @Input()
  public selection: SelectionModel<SnUser>;

  constructor() {
    super();
  }

  public trackBy(index: number, item: SnUser): string {
    return item.id;
  }

  public masterToggle(): void {
    this.isAllSelected() ? this.selection.clear() : this.selection.select(...this.items);
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.items.length;

    return numSelected === numRows;
  }
}
